import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'

export default function MenuRoute() {
	const { currentUser } = useAuth()
	return currentUser ? <Navigate to="/menu" /> : <Outlet />
}
